var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.972,
    height: 20,
    viewBox: "0 0 19.972 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20223",
    "data-name": "Path 20223",
    d: "M21.889,12c-.111-.111-.111-.222-.222-.333L18.333,8.333a1.1,1.1,0,1,0-1.556,1.556l1.444,1.444H13.111A1.05,1.05,0,0,0,12,12.444a1.05,1.05,0,0,0,1.111,1.111h5.111L16.778,15a1.074,1.074,0,0,0,0,1.556,1.074,1.074,0,0,0,1.556,0l3.333-3.333c.111-.111.222-.222.222-.333A1.227,1.227,0,0,0,21.889,12Z",
    transform: "translate(-2 -2.444)",
    fill: "#e81616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20224",
    "data-name": "Path 20224",
    d: "M16.889,19.778a8.107,8.107,0,0,1-3.889,1A7.778,7.778,0,1,1,13,5.222a8.107,8.107,0,0,1,3.889,1,1.144,1.144,0,1,0,1.111-2A11.077,11.077,0,0,0,13,3a10,10,0,1,0,5,18.667,1.23,1.23,0,0,0,.444-1.556A1.2,1.2,0,0,0,16.889,19.778Z",
    transform: "translate(-3 -3)",
    fill: "#e81616"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1a87bf54c8a681db25897e2449e24946.svg";
export { ForwardRef as ReactComponent };